<template>
  <g-page-wrapper>
    <template slot="pageTitle">
      <g-page-title :title="$t('pages_notice_info.path_edit')" :paths="paths"></g-page-title>
    </template>
    <g-contents>
      <div class="-bg-white -pb-12">
        <validation-observer slim v-slot="{invalid}">
          <div class="-tile-container mw-800">
            <div class="-p-5">
              <div class="-font-size-12">
                <div class="-label -width-100 -pb-8">
                  <div class="-wrapper">
                    <p class="-text">{{ $t('pages_notice_info.title') }}</p>
                    <p class="-color-blue-1 -ml-1 -mt-1">*</p>
                  </div>
                  <validation-provider v-slot="{invalid}" rules="required">
                    <g-input-text
                      id="notice-edit-title"
                      maxlength="255"
                      v-model="title"
                      class="-width-100"
                      :placeholder="$t('pages_notice_info.title')"
                      :invalid="invalid"/>
                  </validation-provider>
                </div>
                <div class="-label -width-100 -pb-8">
                  <div class="-wrapper">
                    <p class="-color-blue-1 -ml-1 -mt-1">*</p>
                    <validation-provider rules="required">
                      <div :class="'-validating'">
                        <g-switch id="notice-edit-visible" :text="$t('pages_notice_info.visible_yn')" class="-mr-8" :checked="visible==='Y'" @change="onChangeVisible"/>
                      </div>
                    </validation-provider>
                  </div>
                </div>

                <div class="-label -width-100 -pb-8">
                  <div class="-wrapper">
                    <p class="-text">{{  $t('pages_notice_info.content') }}</p>
                    <p class="-color-blue-1 -ml-1 -mt-1">*</p>
                  </div>
                  <validation-provider v-slot="{invalid}" rules="required">
                    <div :class="'-validating'">
                      <textarea
                        id="notice-edit-content"
                        v-model="contents"
                        class="-input -width-100"
                        rows="10"
                        :placeholder="$t('pages_notice_info.content')"
                        :invalid="invalid">
                      </textarea>
                    </div>
                  </validation-provider>
                </div>
                <div class="-label -width-100 -pb-8">
                  <div class="-wrapper">
                    <p class="-text">{{ $t('pages_notice_create.file')}}</p>
                    <p class="-color-blue-1 -ml-1 -mt-1">*</p>
                  </div>
                  <g-upload-file
                    id="notice-edit-file"
                    :uploadFileList.sync="file.fileList"
                    :extensionList='EXTENSTION_LIST'
                    :progress="file.progress"
                    :file-info="file.info"
                    :cancel-text="$t('common.cancel')"
                    :maxLen="1"
                    @change-file-list="onDropFile"
                    @delete-item="onClickFileDelete"
                    @error="onUploadFileError"
                    :max-len="3">
                    <template #findFile>
                      <g-icon name="publish" color="gray-1"></g-icon>
                      <span class="-color-darkgray-1">{{$t('common.file.1')}}</span>
                      <span class="-border-color-blue-1">{{$t('common.file.2')}}</span>
                    </template>
                  </g-upload-file>
                  <p class="-description -mt-2">{{$t('pages_notice_file.list')}}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="-border-top -py-2 -pr-5 -wrapper end-">
            <g-button variant="secondary"  size="large" bg-color="white" @click="onClickCancel" id="notice-edit-cancle-button">
              {{$t('common.cancel')}}
            </g-button>
            <g-button variant="primary" size="large" class="-mr-0" :disabled="invalid" @click="updateNotice" id="notice-edit-update-button">
              {{$t('common.edit')}}
            </g-button>
          </div>
        </validation-observer>
      </div>
    </g-contents>
  </g-page-wrapper>
</template>

<script>
import {ValidationObserver, ValidationProvider} from 'vee-validate'
import {FileUploader} from '@/library/FileUploader'
import {mapActions, mapGetters} from "vuex";
import ConfirmPopup from "@/pages/components/ConfirmPopup";

export default {
  components: {
    ValidationObserver,
    ValidationProvider
  },
  data() {
    return {
      paths: [{
        path: '/notice/list',
        name: this.$t('pages_notice.path')
      }, {
        path: `/notice/info?id=${this.$route.query.id}`,
        name: this.$t('pages_notice_info.path')
      }, {
        path: `/notice/edit?id=${this.$route.query.id}`,
        name: this.$t('pages_notice_info.path_edit')
      }],
      title: '',
      contents: '',
      fileId: '',
      visible: 'N',
      file: {
        fileList: [],
        progress: {},
        info: {}
      },
      info: {},
      EXTENSTION_LIST: ["gif","jpg","jpeg","png","xls","xlsx","doc","docx","ppt","pptx", "zip", "pdf"]
    }
  },
  computed: {
    ...mapGetters('notice', ['notice', 'selectNotice']),
    ...mapGetters('user', ['userInfo']),
    isUploading () {
      const progressList = Object.values(this.file.progress)
      const isUpload = progressList.reduce((acc, cur) => {
        return [...acc, cur.value]
      }, [])
      return isUpload.every((element) => element === 100)
    }
  },
  methods: {
    ...mapActions('notice', ['getNotice', 'putNoticeWithId']),
    uploadCallback (info) {
      const {file, chunkSize, index} = info
      this.$set(this.file, 'progress', {
        ...this.file.progress,
        [info.id]: {
          type: 'basic',
          value: (chunkSize * index) / file.size * 100,
        }
      })
      this.$set(this.file, 'info', {
        ...this.file.info,
        [info.id]:{
          ...info
        }
      })
      if (info.id && this.file.fileList.filter(item => item.id === info.id).length === 0) {
        const fileList = this.file.fileList.reduce((acc, cur) => {
          if (cur.blob === info.file) {
            cur.id = info.id
          }
          return [...acc, cur]
        }, [])
        this.file.fileList = fileList
      }
    },
    onUploadFileError (error) {
      if('OVERFLOW_FILE_SIZE' === error){
        this.$showToast(this.$t('pages_notice_file.over_size'))
      } else if('NOT_ALLOW_EXTENSTION' === error){
        this.$showToast(this.$t('pages_notice_file.not_allow_extenstion'))
      } else if('MAX_LEN_OVER' === error) {
        this.$showToast(this.$t('common.file_uploading'))
      } else{
        this.$showToast(this.$t('pages_notice_file.error'))
      }
    },
    onChangeVisible(e) {
      this.visible = e ? 'Y' : 'N'
    },
    onClickCancel () {
      this.$router.go(-1)
    },
    endCallback (info) {
      this.uploadCallback(info)
      this.fileId = info.id
      this.$showToast(this.$t('common.file_save'))
    },
    onDropFile (e) {
      const file = e[e.length - 1]
      const fileUploader = new FileUploader(
        {
          file,
          fileFolderPath: 'notice',
          upload: this.uploadCallback,
          end: this.endCallback
        }
      )
      this.file.fileList = e.slice(e.length - 1, e.length)
      fileUploader.upload({name})
    },
    onClickFileDelete (id) {
      const {info, fileList} = this.file
      this.file.fileList = fileList.filter(item => item.id !== id)
      delete this.file.info[file.name]
      delete this.file.progress[file.name]
      this.$showToast(this.$t('common.file_delete'))
    },
    updateNotice() {
      let updateNotice = {
        id: this.notice.id
        , title: this.title
        , content : this.contents
        , fileId : this.fileId
        , tenantCode : '1'
        , visible : this.visible === 'Y'
      }

      this.$popupManager.open(ConfirmPopup, {
        text: this.$t('pages_notice_edit.edit_confirm_message'),
        onConfirm: () => {
          this.putNoticeWithId(updateNotice)
          this.$showToast(this.$t('pages_notice_edit.title_text'))
          this.$router.push('/notice/list')
        }
      })


    }
  },
  beforeMount () {
    const id = this.$route.query.id
    this.getNotice(id)
  },
  watch: {
    notice() {
      if(this.notice.fileId != undefined && this.notice.fileId != null){
        this.file.fileList = [{name: this.notice.fileName, size: this.notice.fileSize, id: this.notice.fileId}]
        this.file.info = {
          [this.notice.fileId]:{
            preview: `${location.origin}/api/v1/files/${this.notice.fileId}`,
            id: this.notice.fileId,
            uploadDate: this.notice.fileCreated,
          }
        }
      }
      this.title = this.notice.title
      this.contents = this.notice.content
      if(this.notice.visible === true){
        this.visible = 'Y'
      }
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/pages/notice/NoticeEdit.vue